import { XCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { UserError } from '../hooks/useErrorHandler';

interface ErrorAlertProps {
  error: UserError | null;
  isVisible: boolean;
  onClose: () => void;
  className?: string;
}

export function ErrorAlert({ error, isVisible, onClose, className = '' }: ErrorAlertProps) {
  if (!error || !isVisible) return null;

  return (
    <div className={`rounded-md bg-red-50 border border-red-200 p-4 ${className}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-red-800">
            Error
            {error.errorCode && (
              <span className="ml-1 text-xs font-mono text-red-600">
                ({error.errorCode})
              </span>
            )}
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <p>{error.message}</p>
            
            {error.details && process.env.NODE_ENV === 'development' && (
              <details className="mt-2">
                <summary className="cursor-pointer text-xs text-red-600 hover:text-red-800">
                  Technical Details
                </summary>
                <pre className="mt-1 text-xs bg-red-100 p-2 rounded overflow-auto">
                  {error.details}
                </pre>
              </details>
            )}
            
            {error.requestId && process.env.NODE_ENV === 'development' && (
              <p className="mt-1 text-xs text-red-600">
                Request ID: {error.requestId}
              </p>
            )}
          </div>
        </div>
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5">
            <button
              type="button"
              className="inline-flex rounded-md bg-red-50 p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50"
              onClick={onClose}
            >
              <span className="sr-only">Dismiss</span>
              <XMarkIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}